export default "__VITE_ASSET__CygHWzRj__"